export default function generate(Service) {
  const state = {
    listPredecessors: [],
    listSuccessors: []
  };
  const getters = {
    getListSuccessors(state) {
      return state.listSuccessors;
    },
    getListPredecessors(state) {
      return state.listPredecessors;
    }
  };

  const actions = {
    getListPredecessors({ commit }, { params = {}, onSuccess = () => {} }) {
      params.limit = params.limit || 25;
      return Service.getListPredecessors(params, ({ list, page }) => {
        commit("setListPredecessors", {
          list,
          page
        });
        onSuccess({ list, page });
      });
    },
    getListSuccessors({ commit }, { params = {}, onSuccess = () => {} }) {
      params.limit = params.limit || 25;
      return Service.getListSuccessors(params, ({ list, page }) => {
        commit("setListSuccessors", {
          list,
          page
        });
        onSuccess({ list, page });
      });
    },
    createPredecessor(
      _,
      { item, errorHandler = () => {}, onSuccess = () => {} }
    ) {
      return Service.createPredecessor(
        {
          ...item
        },
        onSuccess,
        () => {},
        errorHandler
      );
    },
    deletePredecessor(
      _,
      { id, params = {}, onSuccess = () => {}, onError = () => {} }
    ) {
      return Service.deletePredecessor(
        { id, ...params },
        data => {
          onSuccess(data);
        },
        onError
      );
    }
  };

  const mutations = {
    setListSuccessors(state, { list }) {
      state.listSuccessors = list;
    },
    setListPredecessors(state, { list }) {
      state.listPredecessors = list;
    }
  };
  return {
    state,
    getters,
    actions,
    mutations
  };
}
